import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index/index'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
       component (resolve) {
        require(['@/view/index/index.vue'], resolve)
      },
      meta: {
        title: '前言',
        icon: '',
        noCache: true
      }
    },
    {
      path: '/indexdh',
      name: 'indexdh',
      component (resolve) {
        require(['@/view/indexdh/index.vue'], resolve)
      },
      meta: {
        title: '首页',
        icon: '',
        noCache: true
      }
    },

    {
      path: '/preface',
      name: 'preface',
       component (resolve) {
        require(['@/view/preface/preface.vue'], resolve)
      },
      meta: {
        title: '前言',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show1',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show1.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show2',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show2.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show3',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show3.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show4',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show4.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show5',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show5.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show6',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show6.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show7',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show7.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show8',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show8.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },

     {
      path: '/show/show9',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show9.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show10',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show10.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/show/show11',
      name: 'show',
      component(resolve) {
        require(['@/view/show/show11.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },

    {
      path: '/showxj/showxj1',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj1.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/showxj/showxj2',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj2.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/showxj/showxj3',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj3.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/showxj/showxj4',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj4.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/showxj/showxj5',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj5.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },


     {
      path: '/showxj/showxj6',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj6.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/showxj/showxj7',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj7.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
     {
      path: '/showxj/showxj8',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj8.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
    {
      path: '/showxj/showxj9',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj9.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
    {
      path: '/showxj/showxj10',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj10.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
    {
      path: '/showxj/showxj11',
      name: 'showxj',
      component(resolve) {
        require(['@/view/showxj/showxj11.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },
    {
      path: '/bgmusic',
      name: 'bgmusic',
       component (resolve) {
        require(['@/view/bgmusic/bgmusic.vue'], resolve)
      },
      meta: {
        title: '文章',
        icon: '',
        noCache: true
      }
    },

    {
      path: '/List',
      name: 'List',
       component (resolve) {
        require(['@/view/List/List.vue'], resolve)
      },
      meta: {
        title: '列表',
        icon: '',
        noCache: true
      }
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js